import { tenantProjectInfo } from "../models/TenantProjectInfo";
import { projectConfig } from "../project-info/projectConfig";

// used for values in projectConfig.js
export const pickProjectConfigValue = (key) => {
  const tenantValue = tenantProjectInfo.getValue(key);
  if (tenantValue !== null) {
    return tenantValue;
  }
  return projectConfig[key];
};

/** Runtime tenant flag from /user/me (enable_fitness). Missing → projectConfig, then true. */
export const isFitnessEnabled = () => {
  const tenantValue = tenantProjectInfo.getValue('hasFitness');
  if (tenantValue !== null) {
    return !!tenantValue;
  }
  if (Object.prototype.hasOwnProperty.call(projectConfig, 'hasFitness')) {
    return !!projectConfig.hasFitness;
  }
  return true;
};

/** Runtime tenant flag from /user/me (enable_manual_workouts). Missing → projectConfig, then true. */
export const isManualWorkoutsEnabled = () => {
  const tenantValue = tenantProjectInfo.getValue('hasManualWorkouts');
  if (tenantValue !== null) {
    return !!tenantValue;
  }
  if (Object.prototype.hasOwnProperty.call(projectConfig, 'hasManualWorkouts')) {
    return !!projectConfig.hasManualWorkouts;
  }
  return true;
};

// used for values in eventConfig.js
export const pickEventConfigValue = (key, fallback) => {
  const tenantValue = tenantProjectInfo.getValue(key);
  if (tenantValue !== null) {
    return tenantValue;
  }
  return fallback; // maybe use eventConfig, however we have it organized elsewhere and currently are utilizing that instead of re-organizing it
};

